import React from "react";
import { Route, Routes } from "react-router-dom";
import LoginPage from "./pages/login";
import SignUpPage from "./pages/signup";
import DashboardLayout from "./components/dashboard";
import AddDronesPage from "./pages/drones/addDrones";
import MissionPage from "./pages/mission/mission";
import FlightsPage from "./pages/flights/flights";
import VerifyOTPPage from "./pages/verifyOTP";
import GuardedRoute from "./components/ProtectedRoute";
import Page404 from "./pages/404page";
import ForgetPassword from "./pages/forgetPassword";
import NewPassword from "./pages/newPassword";
import ChangePassword from "./pages/changePassword";
import Guidelines from "./pages/guidelines";
import HelpCenter from "./pages/helpCenter";
import Integration from "./pages/inegration";
import DronesPage from "./pages/drones/myDrone";
import DroneDetails from "./pages/drones/droneDetails";
import AirspaceMap from "./pages/airspace"
import FlightDetails from "./pages/flights/flightDetails";
import Issues from "./pages/reportIssue/reportIssuePage";
import ReportIssue from "./pages/reportIssue/addIssue";
import IssueDetails from "./pages/reportIssue/detailIssue";
import MissionDetails from "./pages/mission/missionDetails";
import Layout1 from "./components/layout/layout1";
import AllFlightPage from "./pages/flights/allFlightsPage";
import ManagePilots from "./pages/managePilots/managePilots";
import ManualPage from "./pages/manualPage";
import FlightRecordComponent from "./pages/flightRecordComponent";

const Routing = () => {

  return (
    <Routes>
      <Route path="/" element={<GuardedRoute />} >
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/" element={<AirspaceMap />} />
        {/* Layout1 pages */}
        <Route path="/layout" element={<Layout1 />}>
          <Route path="/layout/manual" element={<ManualPage />} />
          {/* issue routes */}
          <Route path="/layout/issues" element={<Issues />} />
          <Route path="/layout/report-issue" element={<ReportIssue />} />
          <Route path="/layout/issue-details/:issueId" element={<IssueDetails />} />

          {/* other routes */}
          <Route path="/layout/help" element={<HelpCenter />} />
          <Route path="/layout/pilots" element={<ManagePilots />} />
          <Route path="/layout/guidelines" element={<Guidelines />} />
          <Route path="/layout/integration" element={<Integration />} />
          <Route path="/layout/add-drone" element={<AddDronesPage />} />
          <Route path="/layout/flights" element={<AllFlightPage />} />
        </Route>
        {/* dashboard */}
        <Route path="/dashboard" element={<DashboardLayout />}>

          {/* drone routes */}
          <Route index element={<DronesPage />} />
          <Route path="/dashboard/drone-details/:droneId" element={<DroneDetails />} />

          {/* mission routes */}
          <Route path="/dashboard/mission" element={<MissionPage />} />
          <Route path="/dashboard/mission-details/:missionId" element={<MissionDetails />} />

          {/* flight routes */}
          <Route path="/dashboard/flight-details/:flightId" element={<FlightDetails />} />
        </Route>
      </Route>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/flight-records" element={<FlightRecordComponent />} />
      <Route path="/forget-password" element={<ForgetPassword />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/verifyotp" element={<VerifyOTPPage />} />
      <Route path="/new-password" element={<NewPassword />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default Routing;
